/* eslint-disable react/destructuring-assignment */
import React from "react";
import { string, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedDate from "pages/_components/FormattedDate";
import CustomData from "pages/_components/CustomData/CustomData";
import { useSelector } from "react-redux";
import { statusTagColor } from "util/debin";
import InfoTag from "../../_components/InfoTag";

const DataDebin = (props) => {
    const {
        seller = props.seller,
        sellerCuit = props.sellerCuit,
        date = props.date,
        debitAccount = props.debitAccount,
        service = props.service,
        reference = props.reference,
        concept = props.concept,
        description = props.description,
        recurrency = props.recurrency,
        isDesktop = props.isDesktop,
    } = props;

    const { debinRecurrency } = useSelector((state) => state.debin);

    const State = () => (
        <InfoTag
            type="info"
            message={debinRecurrency?.status?.code}
            tagBackground={statusTagColor(debinRecurrency?.status?.code)}
        />
    );

    return (
        <>
            <GridTable className="details debin-credin-list">
                {!isDesktop && (
                    <GridTable.Container columns={2}>
                        <GridTable.Data className="idDebin" columnStart={1} rowStart={1} columnWidth={2}>
                            <CustomData
                                titleText={`ID: `}
                                titleTextType="I18N"
                                valueText={
                                    <CustomText className="ml-4" textType="data-label" text={`${recurrency?.id}`} />
                                }
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={1} columnWidth={isDesktop ? 1 : 3}>
                            <State />
                        </GridTable.Data>
                    </GridTable.Container>
                )}
                <GridTable.Container columns={3}>
                    <GridTable.Data columnStart={1} rowStart={1} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.add.date.label"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={date} dateFormat="DD/MM/YYYY" />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 1 : 2}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.dateExpitation"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={debitAccount} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 1 : 3}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.seller"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={seller} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.seller.cuit"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={sellerCuit} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data className="flex" columnStart={1} rowStart={isDesktop ? 3 : 5} columnWidth={3}>
                        <hr className="dotted" />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 4 : 6} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.service.label"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={service} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 4 : 7}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.reference"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={reference} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 4 : 8}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.concept.label"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={concept} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 9} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.description.label"
                            titleTextType="I18N"
                            valueText={<CustomText className="data-label" text={description} />}
                        />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

DataDebin.propTypes = {
    seller: string,
    sellerCuit: string,
    date: string,
    debitAccount: string,
    service: string,
    reference: string,
    concept: string,
    description: string,
    isDesktop: bool,
    recurrency: string,
};

DataDebin.defaultProps = {
    seller: "",
    sellerCuit: "",
    date: "",
    debitAccount: "",
    service: "",
    reference: "",
    concept: "",
    description: "",
    recurrency: "",
    isDesktop: true,
};

export default DataDebin;
